export const URL_PREFIX_MAPPING = {
  Egypt: "/chat/mena",
  "Saudi Arabia": "/chat/mena",
  "United Arab Emirates": "/chat/mena",
  MENA: "/chat/mena",
  "Costa Rica": "/chat/am",
  Colombia: "/chat/am",
  "Brasil (Brazil)": "/chat/am",
  "United States": "/chat/am",
  Canada: "/chat/am",
  Mexico: "/chat/am",
  "United Kingdom": "/chat/mena",
  "Deutschland (Germany)": "/chat/mena",
  Austria: "/chat/mena",
  India: "/chat/mena",
};

export const Feature = {
  STANDARD_CHAT: "STANDARD_CHAT",
  GRIEVANCE_REPORTING_EMAIL: "GRIEVANCE_REPORTING_EMAIL",
  GRIEVANCE_REPORTING_PHONE: "GRIEVANCE_REPORTING_PHONE",
};

export const COUNTRY_CONFIGURATION = {
  Egypt: {
    English: {
      "Associate / Driver / Marshall / Executive / Administrator / Cashier": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "Egypt",
        language: "English",
        business: "AGENCY_HIRING",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.GRIEVANCE_REPORTING_EMAIL,
      },
    },
  },
  "Saudi Arabia": {
    English: {
      "Associate / Driver / Marshall / Executive / Administrator / Cashier": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "Saudi Arabia",
        language: "English",
        business: "AGENCY_HIRING",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.GRIEVANCE_REPORTING_EMAIL,
      },
    },
  },
  "United Arab Emirates": {
    English: {
      "Associate / Driver / Marshall / Executive / Administrator / Cashier": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United Arab Emirates",
        language: "English",
        business: "AGENCY_HIRING",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.GRIEVANCE_REPORTING_EMAIL,
      },
    },
  },
  MENA: {
    English: {
      "Warehouse / Fulfillment / Delivery": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "MENA",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
    Arabic: {
      "المستودع / الشحن / مندوب توصيل": {
        locale: "ar-AE",
        inputEditorDirection: "rtl",
        country: "MENA",
        language: "Arabic",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  "Costa Rica": {
    Spanish: {
      "Servicio al Cliente": {
        locale: "es-MX",
        inputEditorDirection: "ltr",
        country: "Costa Rica",
        language: "Spanish",
        business: "CUSTOMER_SERVICE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  Colombia: {
    Spanish: {
      "Servicio al Cliente": {
        locale: "es-MX",
        inputEditorDirection: "ltr",
        country: "Colombia",
        language: "Spanish",
        business: "CUSTOMER_SERVICE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  "Brasil (Brazil)": {
    Português: {
      "Serviço ao Cliente": {
        locale: "pt-BR",
        inputEditorDirection: "ltr",
        country: "Brazil",
        language: "Portuguese",
        business: "CUSTOMER_SERVICE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
      "Suporte para candidatura em Centro de distribuição/Armazém logístico": {
        locale: "pt-BR",
        inputEditorDirection: "ltr",
        country: "Brazil",
        language: "Portuguese",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
    English: {
      "Warehouse / Fulfillment Application Support": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "Brazil",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  "United States": {
    English: {
      "Warehouse / Fulfillment / Delivery / Shopper": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.STANDARD_CHAT,
      },
      "Warehouse / Fulfillment / Delivery / Shopper / Amazon Stores (Fresh & Go)": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.STANDARD_CHAT,
      },
      "Warehouse / Fulfillment": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.STANDARD_CHAT,
      },
      "Warehouse / Fulfillment Application Support": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.STANDARD_CHAT,
      },
      "Contact Center / Virtual Contact Center": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "CUSTOMER_SERVICE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
      "Contact Center / Virtual Contact Center Application Support": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "CUSTOMER_SERVICE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
      "Retail / Grocery Stores Application Support": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "PHYSICAL_STORE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
      "Retail / Stores / Grocery": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "PHYSICAL_STORE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
      "Whole Foods Market / Stores / Facilities": {
        locale: "en-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "English",
        business: "WFM",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.STANDARD_CHAT,
      },
    },
    Spanish: {
      "Almacén (Warehouse)": {
        locale: "es-US",
        inputEditorDirection: "ltr",
        country: "United States",
        language: "Spanish",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  Canada: {
    English: {
      "Warehouse / Fulfillment": {
        locale: "en-CA",
        inputEditorDirection: "ltr",
        country: "Canada",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
      "Whole Foods Market / Stores / Facilities": {
        locale: "en-CA",
        inputEditorDirection: "ltr",
        country: "Canada",
        language: "English",
        business: "WFM",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  Mexico: {
    Spanish: {
      Almacén: {
        locale: "es-MX",
        inputEditorDirection: "ltr",
        country: "Mexico",
        language: "Spanish",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  "United Kingdom": {
    English: {
      "Warehouse / Fulfillment": {
        locale: "en-GB",
        inputEditorDirection: "ltr",
        country: "United Kingdom",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  "Deutschland (Germany)": {
    English: {
      "Warehouse / Fulfillment": {
        locale: "en-GB",
        inputEditorDirection: "ltr",
        country: "Deutschland (Germany)",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
    "Deutsch (German)": {
      Versandmitarbeiter: {
        locale: "de-DE",
        inputEditorDirection: "ltr",
        country: "Deutschland (Germany)",
        language: "Deutsch (German)",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  Austria: {
    English: {
      "Warehouse / Fulfillment": {
        locale: "en-GB",
        inputEditorDirection: "ltr",
        country: "Austria",
        language: "English",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
    "Deutsch (German)": {
      Versandmitarbeiter: {
        locale: "de-AT",
        inputEditorDirection: "ltr",
        country: "Austria",
        language: "Deutsch (German)",
        business: "WAREHOUSE",
        channel: "CHAT",
        typingEnabledForBotInteraction: false,
        feature: Feature.STANDARD_CHAT,
      },
    },
  },
  India: {
    English: {
      "Agency Hiring": {
        locale: "en-IN",
        inputEditorDirection: "ltr",
        country: "India",
        language: "English",
        business: "AGENCY_HIRING",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.GRIEVANCE_REPORTING_PHONE,
      },
    },
    Hindi: {
      "Agency Hiring": {
        locale: "hi-IN",
        inputEditorDirection: "ltr",
        country: "India",
        language: "Hindi",
        business: "AGENCY_HIRING",
        channel: "CHAT",
        typingEnabledForBotInteraction: true,
        feature: Feature.GRIEVANCE_REPORTING_PHONE,
      },
    },
  },
};

const ADOBE_DATA_LAYER_URL_NON_PROD =
  "https://assets.adobedtm.com/launch-EN2c38d445ba884f1ca9901284481b2c7b-staging.min.js";
const ADOBE_DATA_LAYER_URL_PROD =
  "https://assets.adobedtm.com/launch-EN6bc43e7eee5146beaa43d868366aabe6.min.js";

export const ADOBE_DATA_LAYER_URL = {
  "gamma-am": ADOBE_DATA_LAYER_URL_NON_PROD,
  "gamma-mena": ADOBE_DATA_LAYER_URL_NON_PROD,
  "preprod-am": ADOBE_DATA_LAYER_URL_NON_PROD,
  "preprod-mena": ADOBE_DATA_LAYER_URL_NON_PROD,
  "prod-am": ADOBE_DATA_LAYER_URL_PROD,
  "prod-mena": ADOBE_DATA_LAYER_URL_PROD,
};
